// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

// Kurumsal palet sınırı — tek kaynak.
//
// Kullanıcı kararı (20.08.2026): menü varsayılanı ELPO lacivert + turkuaz olur ve
// "mor renk burada hiç olmamalı, kullanıcı mor renkleri seçememeli". Mor tema
// önayarları kaldırıldı; geriye Tema Stüdyosu'nun serbest renk seçicisi kalıyordu —
// oradan hâlâ mor girilebiliyordu. Bu modül o kapıyı da kapatır.
//
// Aynı ölçüt derleme zincirindeki scripts/brand-color-guard.mjs içinde de var: orası
// kodu tarar, burası kullanıcının seçimini engeller. Ölçüt tek: renk tonu 232–305
// arası ve doygunluk %20 üstü. Alt sınır 232, çünkü menü vurgusunda duran #818cf8
// tam 234 dereceye düşüyor ve 235'ten kıl payı kaçıyordu; mavi taraf (#a5b4fc 230,
// #60a5fa 213) bu sınırdan etkilenmiyor.

export const ELPO_PALET = {
  lacivert: '#003b5c',
  turkuaz: '#0091b3',
  turkuazAcik: '#4db8d1',
  turuncu: '#ff6a13',
  kirmizi: '#f02137',
} as const;

function hexOku(renk: string): [number, number, number] | null {
  const m = renk.trim().match(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
  if (!m || !m[1]) return null;
  const h = m[1].length === 3 ? [...m[1]].map((c) => c + c).join('') : m[1];
  return [
    parseInt(h.slice(0, 2), 16),
    parseInt(h.slice(2, 4), 16),
    parseInt(h.slice(4, 6), 16),
  ];
}

/**
 * Metin kutusuna yazılan değer UYGULANABİLİR bir renk mi?
 *
 * Kutuya harf harf yazılırken ara değerler de geçerli renk sayılabiliyor: "#8b5cf6"
 * yazarken üçüncü adımda "#8b5" oluşuyor, bu üç haneli kısa yazım olarak okunuyor ve
 * ekranda birincil renk bir anlığına YEŞİLE dönüyordu. Kısa yazım kabul edilmez;
 * yalnız altı haneli hex ile rgb()/rgba() uygulanır.
 */
export function tamRenkMi(deger: string): boolean {
  const d = deger.trim();
  return /^#[0-9a-fA-F]{6}$/.test(d) || /^rgba?\([\d\s.,%/]+\)$/.test(d);
}

/**
 * Mor bir değeri ELPO karşılığına çeker; mor değilse olduğu gibi bırakır.
 *
 * Kod temizlense de KAYITLI tema mor kalabiliyor: ölçüldüğünde dev veritabanındaki
 * tenant teması "Elpo Default" adıyla duruyordu ama menüsü #1d0e5c (koyu mor), vurgusu
 * #818cf8 (indigo) idi — eski koddan kaydedilmiş. Kaydı düzeltmek o veritabanını
 * kurtarır; bu çeviri ise hangi kurulumda olursa olsun mor menünün ekrana çıkmasını
 * engeller.
 *
 * Rol ayrımı: zemin/menü koyu lacivert olur, vurgu turkuaz. Açık bir mor (ör. menüdeki
 * aktif öğe) koyu lacivert yapılırsa okunmaz hale gelir, o yüzden parlaklığa bakılır.
 */
export function markayaCek(renk: string): string {
  if (!morMu(renk)) return renk;
  const rgb = hexOku(renk);
  if (!rgb) return renk;
  const enParlak = Math.max(rgb[0], rgb[1], rgb[2]);
  if (enParlak < 110) return ELPO_PALET.lacivert;
  if (enParlak < 190) return ELPO_PALET.turkuaz;
  return ELPO_PALET.turkuazAcik;
}

/** Renk mor/indigo bandında mı? rgb()/rgba() ve geçersiz değerler için false döner. */
export function morMu(renk: string): boolean {
  const rgb = hexOku(renk);
  if (!rgb) return false;
  const [r, g, b] = [rgb[0] / 255, rgb[1] / 255, rgb[2] / 255];
  const mx = Math.max(r, g, b);
  const mn = Math.min(r, g, b);
  const d = mx - mn;
  if (d === 0) return false;
  // Çok koyu zeminler hesapta mor bandına düşer ama göz onları koyu gri görür.
  if (mx * 255 < 51) return false;
  let t: number;
  if (mx === r) t = ((g - b) / d) % 6;
  else if (mx === g) t = (b - r) / d + 2;
  else t = (r - g) / d + 4;
  let ton = Math.round(t * 60);
  if (ton < 0) ton += 360;
  return ton >= 232 && ton <= 305 && Math.round((d / mx) * 100) >= 20;
}
